<script setup lang="ts">
import UserManualDialog from "./UserManualDialog.vue";
import { ref } from "vue";
import { getQueryParameter } from "../../utils/GeneralUtils.ts";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

const route = useRoute();
const manualOpen = ref(getQueryParameter(route, "search") !== undefined);

const { t } = useI18n();

const toggleDialog = (state: boolean) => {
    manualOpen.value = state;
};
</script>

<template>
    <Button
        id="user-manual_btn_manual"
        :aria-label="t('footer.persologWorldMenu.help')"
        class="manual desktop-only"
        icon="pi pi-question"
        text
        rounded
        @click="toggleDialog(true)"
    ></Button>
    <UserManualDialog v-if="manualOpen" :visible="manualOpen" @update:visible="toggleDialog" />
</template>

<style scoped>
.manual {
    padding-left: 4.16px !important;
}

@media (min-width: 768px) {
    .desktop-only {
        display: inline;
    }
}
</style>
